// FileUploadModal.js
import React, { useState, useRef, useEffect } from "react";
import { FiUpload } from "react-icons/fi";
import "./FileUploadModal.css";

const FileUploadModal = ({ isOpen, onClose }) => {
  const [files, setFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const modalRef = useRef(null); // Reference for the modal
  const fileInputRef = useRef(null); // Reference for the hidden input

  const handleFileUpload = (event) => {
    const uploadedFiles = Array.from(event.target.files);
    setFiles(uploadedFiles);
    setUploadProgress(0);
    simulateUpload();
  };

  const simulateUpload = () => {
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      setUploadProgress(progress);
      if (progress >= 100) clearInterval(interval);
    }, 300);
  };

  // Function to handle clicks outside the modal
  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      onClose();
    }
  };

  // Attach event listener on mount and clean up on unmount
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Function to trigger file input click
  const openFileDialog = () => {
    fileInputRef.current.click();
  };

  return (
    <div
      className="modal-overlay"
      style={{ display: isOpen ? "flex" : "none" }}
    >
      <div className="modal-content" ref={modalRef}>
        <h2>File Upload</h2>

        {/* Clickable Drag and Drop Area */}
        <div className="drag-drop-area" onClick={openFileDialog}>
          <FiUpload size={40} />
          <p>
            Drag and drop or <span>browse</span> your files
          </p>
        </div>

        {/* Hidden File Input */}
        <input
          type="file"
          multiple
          ref={fileInputRef}
          onChange={handleFileUpload}
          className="file-input"
        />

        {files.length > 0 && (
          <div className="file-preview">
            {files.map((file, index) => (
              <div key={index} className="file-item">
                <p>{file.name}</p>
                <div className="progress-bar">
                  <div
                    className="progress"
                    style={{ width: `${uploadProgress}%` }}
                  ></div>
                  <span>{uploadProgress}%</span>
                </div>
              </div>
            ))}
          </div>
        )}
        <button
          className="upload-done-button"
          disabled={uploadProgress < 100}
          onClick={onClose}
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default FileUploadModal;
